import React from "react";
import PageRenderer from "../components/PageRender";

const CookiePolicy = () => {
  return <PageRenderer pageIdentifier="cookie-policy" />;
};

export default CookiePolicy;
